
const useIsHelpCenterSearchResultV2Enabled = () => true;

export default useIsHelpCenterSearchResultV2Enabled;
